<section class="page-container">
  <div class="flex min-w-0 items-center justify-between gap-4">
    <h1 class="main-heading min-w-0">Vehicle Selection</h1>
    <app-navpath class="hidden md:block" />
  </div>
  <section class="content-container">
    <section>
      <app-data-form
        class="vehicle-selection-form"
        [dataFields]="upperFormFields"
        [dataName]="'upperFormFields'"
        [columns]="0"
        (updateFields_child)="handleUpdate($event)"
      ></app-data-form>
    </section> 

    <div *ngIf="tableVisible" class="w-full overflow-x-auto">
      <app-data-table
        class="block min-w-[64rem]"
        [tableHeaders]="tableHeaders_vehicleStock"
        [tableEntries]="filteredData"
      ></app-data-table>
    </div>

   <div *ngIf="specVisible">
      <h2 class="sub-heading w-full border-b">
        Standard specification
      </h2>
      <app-data-form
        [dataFields]="standardSpecification"
        [dataName]="'standardSpecification'"
      ></app-data-form>

      <div class="mb-4 grid grid-cols-1 gap-4 lg:grid-cols-2">
        <div class="min-w-0">
          <h2 class="sub-heading w-full border-b">
            Standard accessories
          </h2>
          <div class="w-full overflow-x-auto">
            <app-data-table
              class="block min-w-[20rem]"
              [tableHeaders]="tableHeaders_standardAccessories"
              [tableEntries]="standardAccessories"
              [pagination]="false"
            ></app-data-table>
          </div>
        </div>
        <div class="min-w-0">
          <h2 class="sub-heading w-full border-b">
            Optional accessories
          </h2>
          <div class="w-full overflow-x-auto">
            <app-data-table
              class="block min-w-[24rem]"
              [tableHeaders]="tableHeaders_optionalAccessories"
              [tableEntries]="optionalAccessories"
              [pagination]="false"
            ></app-data-table>
          </div>
        </div>
      </div>

      <button class="shorter-btn misc-btn w-full md:w-auto" (click)="goToBooking()">
        <fa-icon [icon]="faSignInAlt" class="mr-1" />Proceed to Booking
      </button>
    </div>
  </section>
</section>
